<ul class="results-container" #listContainer>
  <li
    *ngFor="let place of results;"
    class="result-item"
    (click)="onSelect(place)"
  >
    <div class="icon-wrapper">
      <i class="fa-location-dot-alt"></i>
    </div>

    <div class="text-content">
      <p class="place-title" [innerHTML]="place.mainText | highlightText: searchTerm"></p>
      <p class="place-subtitle">{{ place.secondaryText }}</p>
    </div>
  </li>
</ul>
